


















































    import AbpBase from "../../lib/abpbase";
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import ECharts from 'vue-echarts'
    import Util from '../../lib/util'

    import {GetPatBeforeHistData,GetPatBeforeHistBpData,GetPatRecHistData} from '../../api/dialysisProcess'


    @Component({
        components:{ECharts,}
    })
    export default class  extends AbpBase {
        @Prop({type:Object,default:{}}) options:any;
        @Prop({type:Object,default:{}}) data:any;
        dataE:any = {}
        optionsData:any = {
            datas:{},
        }

        //简明历史
        hisType:any = ['综合数据','患者评估','抗凝模式','透前血压','透后血压','体重','实际体重变化','实际超滤量','透后小结']
        hisTypeActive = 0


        //历史数据
        date:any = []
        period:any = '最近一月'
        async getData(){
            let data,res,hisData;
            switch(this.options.name){
                case 'weight':
                data = {
                    StartDate:this.date[0]?this.formatDate(this.date[0]):"",
                    EndDate:this.date[1]?this.formatDate(this.date[1]):"",
                    PatientId:this.data.patientId
                }
                res = await GetPatBeforeHistData(data)
                this.optionsData.datas.categoryData = res.objects.map((item:any)=>{
                    return Util.formatTime(item.date)
                })
                hisData = res.objects.map((item:any)=>{
                    return item.beforeWeight
                })
                this.optionsData.datas.valueData = [hisData]
                this.createdCharts()
                break;
                case 'bp':
                data = {
                    StartDate:this.date[0]?this.formatDate(this.date[0]):"",
                    EndDate:this.date[1]?this.formatDate(this.date[1]):"",
                    PatientId:this.data.patientId
                }
                res = await GetPatBeforeHistBpData(data)
                this.optionsData.datas.categoryData = res.objects.map((item:any)=>{
                    return Util.formatTime(item.date)
                })
                let hisData1 = []
                let hisData2 = []
                hisData1 = res.objects.map((item:any)=>{
                    return item.beforeSbp
                })
                hisData2 = res.objects.map((item:any)=>{
                    return item.beforeDbp
                })
                hisData = [hisData1,hisData2]
                this.optionsData.datas.valueData = hisData
                this.createdCharts()
                break;
                case 'rec':
                //简明历史
                await this.getPatRecHistData()
                break;
            }
        }
        async getPatRecHistData(){
            let data = {
                Type:this.hisTypeActive,
                StartDate:this.date[0]?this.formatDate(this.date[0]):"",
                EndDate:this.date[1]?this.formatDate(this.date[1]):"",
                PatientId:this.data.patientId
            }
            let res = await GetPatRecHistData(data)
            //表格状态数据
            if(this.hisTypeActive == 0 ||this.hisTypeActive == 1 ||this.hisTypeActive == 2 ||this.hisTypeActive == 6||this.hisTypeActive==8){
                this.list = res.objects;
                this.createdTable(this.hisTypeActive)
            }else{
            //图表状态
                this.optionsData.datas.categoryData = res.objects.map((item:any)=>{
                    return Util.formatTime(item.dialysisDate)
                })
                let hisData1 = []
                let hisData2 = []
                let hisData = []
                switch(this.hisTypeActive){
                    case 3:
                    //legendName重写
                    this.options.legendName = ['收缩压','舒张压']
                    hisData1 = res.objects.map((item:any)=>{
                        return item.beforeSbp
                    })
                    hisData2 = res.objects.map((item:any)=>{
                        return item.beforeDbp
                    })
                    hisData = [hisData1,hisData2]
                    this.optionsData.datas.valueData = hisData
                    break;
                    case 4:
                    //legendName重写
                    this.options.legendName = ['收缩压','舒张压']
                    hisData1 = res.objects.map((item:any)=>{
                        return item.afterSbp
                    })
                    hisData2 = res.objects.map((item:any)=>{
                        return item.afterDbp
                    })
                    hisData = [hisData1,hisData2]
                    this.optionsData.datas.valueData = hisData
                    break;
                    case 5:
                    //legendName重写
                    this.options.legendName = ['透前体重','透后体重']
                    hisData1 = res.objects.map((item:any)=>{
                        return item.beforeWeight
                    })
                    hisData2 = res.objects.map((item:any)=>{
                        return item.afterWeight
                    })
                    hisData = [hisData1,hisData2]
                    this.optionsData.datas.valueData = hisData
                    break;
                    case 7:
                     //legendName重写
                    this.options.legendName = ['实际超滤量']
                    hisData1 = res.objects.map((item:any)=>{
                        return item.actUfv
                    })
                    hisData = [hisData1]
                    this.optionsData.datas.valueData = hisData
                    break;
                }
                this.createdCharts()
            }
            console.log(res)
        }
        hisTypeChange(index:any){
            this.hisTypeActive = index
            this.getData()
        }

        async created() {
            this.hisChange(this.period)
            console.log(this.options)
            // switch(this.options.name){
            //     case 'weight':
            //     await this.getData()
            //     break;
            // }
            await this.getData()

        }
        column:any = []
        list:any = []
        createdTable(typeIndex:any){
            switch(typeIndex){
                case 0:
                this.column = [
                    {
                        title:'时间',
                        key:'dialysisDate',
                        render: (h:any ,params:any)=>{
                            return h('span',Util.formatTime(params.row.dialysisDate))
                        }
                    },
                    {
                        title:'透前血压(mmHg)',
                        key:'bp'
                    },
                    {
                        title:'透前体重(Kg)',
                        key:'beforeWeight'
                    },
                    {
                        title:'透后体重(Kg)',
                        key:'afterWeight'
                    },
                    {
                        title:'干体重(Kg)',
                        key:'dryWeight'
                    },
                    {
                        title:'预设超滤量(ml)',
                        key:'preUfv'
                    },
                    {
                        title:'实际超滤量(ml)',
                        key:'actUfv'
                    },
                ]
                break;
                case 1:
                this.column = [
                    {
                        title:'时间',
                        key:'dialysisDate',
                        render: (h:any ,params:any)=>{
                            return h('span',Util.formatTime(params.row.dialysisDate))
                        }
                    },
                    {
                        title:'原因',
                        key:'reason'
                    },
                    {
                        title:'解决方案',
                        key:'solution'
                    }
                ]
                break;

                case 2:
                this.column = [
                    {
                        title:'时间',
                        key:'dialysisDate',
                        render: (h:any ,params:any)=>{
                            return h('span',Util.formatTime(params.row.dialysisDate))
                        }
                    },
                    {
                        title:'内容',
                        key:'content'
                    },
                    {
                        title:'操作人',
                        key:'solution'
                    }
                ]
                break;

                case 6:
                this.column = [
                    {
                        title:'时间',
                        key:'dialysisDate',
                        render: (h:any ,params:any)=>{
                            return h('span',Util.formatTime(params.row.dialysisDate))
                        }
                    },
                    {
                        title:'透前体重(Kg)',
                        key:'beforeWeight'
                    },
                    {
                        title:'透后体重(Kg)',
                        key:'afterWeight'
                    },
                    {
                        title:'实际体重变化(Kg)',
                        key:'actWeight'
                    },
                     {
                        title:'干体重(Kg)',
                        key:'dryWeight'
                    }

                ]
                break;

                case 8:
                this.column = [
                    {
                        title:'时间',
                        key:'dialysisDate',
                        render: (h:any ,params:any)=>{
                            return h('span',Util.formatTime(params.row.dialysisDate))
                        }
                    },
                    {
                        title:'内容',
                        key:'summary'
                    },

                ]
                break;

            }
        }
        createdCharts() {
            this.dataE = {
                legend: {
                    data:this.options.legendName
                },
                grid: {
                    bottom: 60,
                    left:80,
                    right:80,
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        lineStyle:{
                            color: '#009688',
                            width: 2,
                            type: 'solid'
                        }
                    }
                },
                xAxis: {
                    data: this.optionsData.datas.categoryData,
                    silent: false,
                    axisTick:{ show:false},
                    splitLine: {
                        show: true,
                        lineStyle:{
                            color: '#EBEBEB',
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            type: 'solid',
                            color: '#009688',
                            width: '2'
                        }
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#000'
                        }
                    }
                },
                yAxis:this.fillyAxis(),
                series:this.fillSeries()
            };

        }
        fillyAxis(){
            let yAxis:any = []
            this.options.legendName.forEach((item:any,index:number) => {
                yAxis.push({
                    splitArea: {
                        show: true,
                        areaStyle:{
                            color:['#FFFFFF','#F9F9F9']
                        }
                    },
                    axisTick:{ show:false},
                    axisLine: {
                        lineStyle: {
                            type: 'solid',
                            color: '#009688',
                            width: '2'
                        }
                    },
                    splitNumber:5,
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#000'
                        }
                    }
                })
            });
            return yAxis;
        }
        fillSeries(){
            let series:any = []
            this.options.legendName.forEach((item:any,index:number) => {
                console.log(this.optionsData)
                series.push({
                    type: this.options.type,
                    name:item,
                    data: this.optionsData.datas.valueData[index],
                    large: true,
                    smooth:true,
                    color:index==0?'#009688':'#5cadff'
                })

            });
            return series;
        }

        hisChange(val:any){
            switch (val) {
				case '全部':
                    this.date = []
                    this.getData()
					break
				case '最近一周':
					this.setDate(7)
					break
				case '最近一月':
					this.setDate(30)
					break
				case '最近半年':
					this.setDate(182)
					break
				case '最近一年':
					this.setDate(365)
					break
				case '最近三年':
					this.setDate(365 * 3)
					break
			}
        }
        setDate(days: number) {
			const end = new Date()
			let start = new Date()
			start.setTime(start.getTime() - 3600 * 1000 * days * 24);
            this.date = [start, end]
            this.getData()
        }



    }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/charts/multipleDataEchart.vue